var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgExpiryInfoCircleOutlined = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0468 22.0253C6.524 22.037 2.03736 17.5693 2.02563 12.0465C2.0139 6.52371 6.48153 2.03706 12.0044 2.02533C17.5272 2.01361 22.0139 6.48124 22.0256 12.0041C22.0373 17.5269 17.5696 22.0136 12.0468 22.0253ZM12.0426 20.0253C16.4609 20.0159 20.035 16.4266 20.0256 12.0083C20.0162 7.59005 16.4269 4.01595 12.0086 4.02533C7.59035 4.03471 4.01624 7.62403 4.02562 12.0423C4.03501 16.4606 7.62432 20.0347 12.0426 20.0253ZM11.015 7.02745L13.015 7.0232L13.0192 9.02319L11.0192 9.02744L11.015 7.02745ZM11.0235 11.0274L13.0235 11.0232L13.0362 17.0232L11.0362 17.0274L11.0235 11.0274Z",
    fill: "#F5AE00"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExpiryInfoCircleOutlined, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ExpiryInfoCircleOutlined.59f9b9ca.svg";
export { ForwardRef as ReactComponent };